import { createApp } from "vue";
import App from "./App.vue";
import AuthView from "@/views/AuthView.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import router from "./router";
import store from "./store";
import "./main.css";
import apiClient from "@/api/apiClient";

const main = async () => {
  try {
    const { data } = await apiClient.get("whoami");
    store.commit("setUser", data);
    createApp(App)
      .use(store)
      .use(router)
      .component("SvgIcon", SvgIcon)
      .mount("#app");
  } catch (e) {
    console.log(e.message);
    createApp(AuthView)
      .use(store)
      .use(router)
      .component("SvgIcon", SvgIcon)
      .mount("#app");
  }
};

main();
